import {EntityService} from '../../../service/EntityService';

export class CustomerService extends EntityService {
  static entity = 'iam-party/customers';

  static downloadExcel(params: any): Promise<Blob> {
    return this.axios.get(`${this.entity}/download-excel`, {params, responseType: 'blob'}).then(res => res.data);
  }

  static approve(id: string): Promise<any> {
    return this.axios.put(`${this.entity}/${id}/approve`).then(res => res.data);
  }
}
